import {Text} from '@dropbox/dig-components/typography';
import {Split, Stack} from '@dropbox/dig-foundations';
import {Title} from 'components/DSYS/Title';
import {format} from 'date-fns';

import {DashboardState} from './dashboardModel';
import {greetingForTime} from './phases';

export const DashboardHeader = ({
  state,
  firstName,
}: {
  state: DashboardState;
  firstName?: string;
}) => {
  const date = new Date(state.now);

  return (
    <Split alignY="center" gap="16">
      <Split.Item width="fill">
        <Stack gap="2">
          <Title size={24}>
            {greetingForTime(state.now)}
            {firstName && `, ${firstName}`}
          </Title>
          <Text color="subtle">{format(date, 'EEEE, MMMM d')}</Text>
        </Stack>
      </Split.Item>
    </Split>
  );
};
